// extracted by mini-css-extract-plugin
export default {"root":"UploadFile_root__og+Mb","input":"UploadFile_input__qnuMs","actionMessage":"UploadFile_actionMessage__8E3xU","isActive":"UploadFile_isActive__graXp"};